import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Teodor Sandu
 * id EB23B6A0-2021-405D-83F2-D69D9A5CF1CD
 * name curtains-closed
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/curtains-closed.svg
 * tags
 * - Home Automation 
 */
export const CurtainsClosedIcon = createSvgIcon(<><path d="M23 3H1V1H23V3M2 22H11V4H2V22M22 4H13V22H22V4Z" /></>, 'CurtainsClosedIcon');
export default CurtainsClosedIcon